// src/constants/languages.js
// Lingue supportate dal sito e lingua di default (usata come fallback
// e come destinazione dei redirect dai vecchi indirizzi senza prefisso).
export const SUPPORTED_LANGS = ["it", "en"];
export const DEFAULT_LANG = "it";

export const isSupportedLang = (value) => SUPPORTED_LANGS.includes(value);
